import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=362c8438&scoped=true"
import script from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=362c8438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c8438",
  null
  
)

export default component.exports